import React, { createContext, useMemo, useState } from "react";

export const ForwardMessageContext = createContext();

export const ForwardMessageProvider = ({ children }) => {
  const [selectedForwardMessages, setSelectedForwardMessages] = useState([]);
  const [isForwardSelectionMode, setIsForwardSelectionMode] = useState(false);
  const [isForwardModalOpen, setIsForwardModalOpen] = useState(false);

  const startForwardSelection = (message) => {
    if (!message?.id) return;

    setIsForwardSelectionMode(true);
    setIsForwardModalOpen(false);
    setSelectedForwardMessages([message]);
  };

  const toggleForwardMessage = (message) => {
    if (!message?.id) return;

    setSelectedForwardMessages((prev) => {
      const exists = prev.some((item) => String(item.id) === String(message.id));
      if (exists) {
        return prev.filter((item) => String(item.id) !== String(message.id));
      }
      return [...prev, message];
    });
  };

  const openForwardModal = () => {
    setIsForwardModalOpen(true);
  };

  const closeForwardModal = () => {
    setIsForwardModalOpen(false);
  };

  const clearForwardSelection = () => {
    setSelectedForwardMessages([]);
    setIsForwardSelectionMode(false);
    setIsForwardModalOpen(false);
  };

  const value = useMemo(() => ({
    selectedForwardMessages,
    isForwardSelectionMode,
    isForwardModalOpen,
    startForwardSelection,
    toggleForwardMessage,
    openForwardModal,
    closeForwardModal,
    clearForwardSelection
  }), [selectedForwardMessages, isForwardSelectionMode, isForwardModalOpen]);

  return (
    <ForwardMessageContext.Provider value={value}>
      {children}
    </ForwardMessageContext.Provider>
  );
};
